const packageFile = {
  name: "test",
  version: "0.0.1",
  description: "test description",
  main: "index.js",
  keywords: ["patternx"],
  author: "John Rees <john@wikihouse.cc>",
  dependencies: {
    three: "^0.87.1"
  }
};

function createFiles(indexContent) {
  return {
    "package.json": {
      content: JSON.stringify(packageFile, null, 2),
      language: "JSON",
      type: "application/json"
    },
    "graph.js": {
      content: JSON.stringify(indexContent, null, 2),
      language: "Javascript",
      type: "application/javascript"
    },
    "README.md": {
      content: "## Test File\nGenerated by Pattern⨯",
      language: "Markdown",
      type: "text/plain"
    }
  };
}

module.exports = {
  createFiles
};



// WEBPACK FOOTER //
// ./src/github/files.js